module.exports = __webpack_public_path__ + "img/Feature.06882238.png";